import makeLookupModal from "../../UI/LookupModal/LookupModal";
import CourseLookup from "./CourseLookup";
const CourseLookupModal = makeLookupModal(CourseLookup, {
    pluralEntityName: "Courses",
});
export default CourseLookupModal;
